import Badge, { SuccessBadge } from './template';
export default Badge;
export { SuccessBadge };
